// @flow

import type { PendingIncomingPayment } from './types';
import { getGateway } from '@tectonics/prs/gateway';

export function getGatewayBankCode(incomingPayment: PendingIncomingPayment): ?string {
  const gateway = getGateway(incomingPayment);
  return gateway['bank_code'];
}

export function getSafeGatewayBankCode(incomingPayment: PendingIncomingPayment): string {
  const code = getGatewayBankCode(incomingPayment);
  if (!code) {
    throw new Error('getSafeGatewayBankCode - there is no bank code in the incoming payment');
  }
  return code;
}
